import Vue from "vue";
import Vuex from "vuex";
import { createStore, Module } from "vuex-smart-module";

import { authModule } from "./auth";
import { userModule } from "./user";
import { targetsModule } from "./targets";
import { mapModule } from "./maps";
import { featuresModule } from "./features"
import { userAdminModule } from "./user_admin";
import { gruposModule } from "./grupos"

Vue.use(Vuex);

export const root = new Module({
  modules: {
    authModule,
    userModule,
    targetsModule,
    mapModule,
    featuresModule,
    userAdminModule,
     gruposModule, // NUEVO
  },
});

const store = createStore(root);
export default store

export const auth = authModule.context(store)
export const user = userModule.context(store)
export const targets = targetsModule.context(store)
export const maps = mapModule.context(store)
export const features = featuresModule.context(store)
export const UserAdmin = userAdminModule.context(store)
export const grupos = gruposModule.context(store)